<template>
  <div class="login-page-component-container">
    <div class="component-wrapper">
      <LoginHeader />
      <div class="login-page-container scroll-bar">
        <div class="login-form-container">
          <div class="form-container">
            <form class="login-form" @submit="loggingIn">
              <div class="info-text-container">
                <p class="info-text">{{ $t('enter_info_to_login') }}</p>
              </div>
              <div class="input-container">
                <div class="form-section-wrapper">
                  <input
                    id="email"
                    class="form-input"
                    :class="[{'error-unknown-email': unknownEmailAddress, 'blocked': loginLoading}]"
                    name="email"
                    type="email"
                    :placeholder="$t('enter_email_address') + '...'"
                    required
                  />
                </div>
                <div v-if="unknownEmailAddress" class="error-msg-unknown-email-container">
                  <p class="red">{{ $t(`${loginErrorMsg}`) }}</p>
                </div>
              </div>
              <div class="input-container">
                <div class="form-section-wrapper password-section-container">
                  <div class="show-hide-password-container" @click="showHidePassword">
                    <img :src="require(`../../assets/icons/${showPassword ? 'show' : 'hide'}_password.png`)" alt="password icon" />
                  </div>
                  <div class="password-input-container">
                    <input
                      id="password"
                      class="form-input"
                      :class="[{'error-incorrect-password': incorrectPassword, 'blocked': loginLoading}]"
                      :type="showPassword ? 'text' : 'password'"
                      name="password"
                      :placeholder="$t('enter_password') + '...'"
                      required
                    />
                  </div>
                </div>
                <div v-if="incorrectPassword" class="error-msg-incorrect-password-container">
                  <p class="red">{{ $t(`${loginErrorMsg}`) }}</p>
                </div>
              </div>
              <div class="options-container">
                <div class="remember-me-container">
                  <div class="form-section-wrapper checkbox-wrapper">
                    <div class="checkbox-container">
                      <label v-if="$store.requestSource.includes('webView')" for="remember-me" class="custom-checkbox">
                        <input type="checkbox" id="remember-me" name="rememberMe" class="form-checkbox" />
                        <span class="checkmark"></span>
                        {{ $t('remember_me') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-section-wrapper forget-password-wrapper">
                <p class="forget-password-text" @click="displayForgetPasswordPage">{{ $t('forget_password') }}</p>
              </div>
              <div class="form-section-wrapper login-btn-and-error-msg-container">
                <div class="login-btn-wrapper">
                  <div v-if="loginLoading" class="loading-spinner-container">
                    <div class="spinner">
                      <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image" />
                    </div>
                  </div>
                  <input v-else id="login-btn" class="login-btn btn" type="submit" :value="$t('login')" />
                </div>
                <div class="login-error-msg-container">
                  <p v-if="loginFailed && !unknownEmailAddress && !incorrectPassword" class="login-error-msg red">
                    {{ $t(`${loginErrorMsg}`) }}
                  </p>
                </div>
              </div>
            </form>

            <div class="can-not-login-text-container">
              <div class="registration-container">
                <p>{{ $t('dont_have_account_yet') }} <span class="register-btn" @click="displayRegisterPage">{{ $t('register_now') }}</span></p>
              </div>
              <p>{{ $t('cant_login') }}</p>
              <p>{{ $t('ask_trainer_for_hulp') }}</p>
            </div>
          </div>
        </div>
      </div>
      <LoginFooter />
    </div>
  </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
export default {
  name: 'LoginPage',
  components: {
    LoginHeader,
    LoginFooter,
  },
  data() {
    return {
      loginLoading: false,
      unknownEmailAddress: false,
      incorrectPassword: false,
      showPassword: false,
      loginFailed: false,
      loginErrorMsg: '',
    };
  },
  methods: {
    showHidePassword: function () {
      this.showPassword = !this.showPassword;
    },
    showLoginData: async function () {
      if (this.$store.requestSource.includes("webView")) {
        const emailInput = document.getElementById('email');
        const rememberMe = document.getElementById('remember-me');
        const loginData = {
          email: emailInput.value,
          rememberMe: rememberMe.checked,
        };
        try {
          await window.flutter_webView_get_login_data.postMessage(JSON.stringify(loginData));
        } catch (err) {
          console.log('error in sending user data to webview');
          console.log(err);
        }
      }
    },
    displayForgetPasswordPage: function () {
      this.$router.push('/forget-password');
    },
    displayRegisterPage: function () {
      this.$router.push('/register');
    },
    loggingIn: async function (e) {
      e.preventDefault();

      this.loginFailed = false;
      this.loginLoading = false;
      this.loginFailed = false;
      this.loginErrorMsg = '';
      this.unknownEmailAddress = false;
      this.incorrectPassword = false;
      this.$store.resetStoreUser();

      const loginBtn = document.getElementById('login-btn');
      loginBtn.disabled = true;
      this.loginLoading = true;

      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;
      let rememberMe;
      let user;

      if (this.$store.requestSource.includes("webView")) {
        const checkbox = document.getElementById('remember-me');
        if (checkbox) {
          rememberMe = checkbox.checked ? true : false;
          if (!rememberMe) {
            await window.flutter_webView_remove_cached_user.postMessage('true');
          }
          user = {
            email,
            password,
            rememberMe,
          };
        } else {
          user = {
            email,
            password,
            rememberMe: false,
          };
        }
      } else {
        user = {
          email,
          password,
        };
      }

      try {
        const loginResponse = await fetch('/api/user/login', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(user),
        });

        const loginResponseJson = await loginResponse.json();

        // console.log(loginResponseJson);

        if (!loginResponseJson.status) {
          if (loginResponseJson.confirmWarning) {
            this.$store.unconfirmedAccount = true;
            this.$store.showFooterBackBtn = true;
            this.$store.user.email = email;
            this.$router.push('/confirm');
          } else {
            if (loginResponseJson.unknownEmailAddress) {
              this.unknownEmailAddress = true;
            }
            if (loginResponseJson.incorrectPassword) {
              this.incorrectPassword = true;
            }
            this.loginErrorMsg = loginResponseJson.message;
          }
          this.loginFailed = true;
          loginBtn.disabled = false;
          this.loginLoading = false;
        } else {
          if (loginResponseJson.token && loginResponseJson.token != '') {
            this.$store.user.email = email;
            this.$store.user.confirmedEmail = loginResponseJson.user.confirmInfo.status;
            this.$store.user.token = loginResponseJson.token;
            this.$store.user.firstName = loginResponseJson.user.firstName;
            this.$store.user.lastName = loginResponseJson.user.lastName;
            this.$store.user.country_code = loginResponseJson.studiosInfo[0].country_code;
            this.$store.user.zohoId = loginResponseJson.user.zohoId;
            this.$store.user.moduleType = loginResponseJson.user.moduleType;
            this.$store.user.newsLink = loginResponseJson.newsLink;
            this.$store.user.studiosInfo = loginResponseJson.studiosInfo;
            this.$store.user.type = loginResponseJson.user.type;
            this.$store.planning = loginResponseJson.planning;

            // console.log("this.$store.planning: " + this.$store.planning);

            const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${loginResponseJson.user.zohoId}.png`;
            const profileImgExist = await this.$store.checkOnlineImageExist(url);
            if (profileImgExist) {
              this.$store.user.profileImgUrl = url;
            }
            else {
              this.$store.user.profileImgUrl = require("@/assets/imgs/placeholder_user_img.png");
            }

            if (loginResponseJson.userInfoToMobile != null) {
              this.$store.user.mobileId = loginResponseJson.userInfoToMobile.mobileId;
              await window.flutter_webView_user_data.postMessage(JSON.stringify(loginResponseJson.userInfoToMobile));
            }

            // Check if the user changed the app language before login and the new app language should be saved to the user profile in db.
            if (this.$store.appLanguageChangedBeforeLogin && this.$store.selectedAppLanguage != loginResponseJson.user.appLanguage) {
              // console.log("Updating app language in db...");
              this.$store.appLanguageChangedBeforeLogin = false;
              const data = {
                email: email,
                token: loginResponseJson.token,
                appLang: this.$store.selectedAppLanguage.toLowerCase(),
              };

              await fetch("../../api/user/updateAppLanguage", {
                method: "POST",
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify(data),
              });

              // const updateAppLanguageResponseJson = await updateAppLanguageResponse.json();

              // console.log(updateAppLanguageResponseJson);
            }
            else {
              this.$store.selectedAppLanguage = loginResponseJson.user.appLanguage; 
            }

            const localStorageData = {
              email: email,
              token: loginResponseJson.token,
            };
            this.$store.setLocalStorage('user', localStorageData);
            this.$store.activeNavBarButton = 'home';
            this.$router.push({ path: '/home', query: { firstLogin: true } });
          }
        }
      } catch (err) {
        console.log('something_went_wrong_try_again');
        console.log(err);
        this.loginErrorMsg = 'something_went_wrong_try_again';
        this.loginFailed = true;
        loginBtn.disabled = false;
        this.loginLoading = false;
      }
    },
  },
};
</script>

<style>
.login-page-component-container {
  position: relative;
  height: 100vh;
  width: 100%;
}

.login-page-component-container .component-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.login-page-component-container .login-page-container {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.login-page-component-container .login-form-container {
  width: 88%;
  max-width: 500px;
  height: 100%;
}

.login-page-component-container .form-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.login-page-component-container .login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}

.login-page-component-container .info-text-container {
  width: 100%;
  max-width: 275px;
  padding: calc(11%) 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-page-component-container .info-text {
  font-size: 30px;
  font-family: 'VAG Rounded Std', sans-serif;
  color: #a0a1a3;
  text-align: center;
  line-height: 35px;
}

.login-page-component-container .input-container {
  width: 100%;
  height: 70px;
}

.login-page-component-container .input-container:nth-of-type(3) {
  height: 55px;
}

.login-page-component-container .form-input {
  width: 100%;
  padding: 8px 6px 6px 8px;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
  border: 1px solid #92d400;
  border-radius: 10px;
  color: #000000;
  display: inline-block;
}

.login-page-component-container .form-input:focus {
  outline: 1px solid #92d400;
}

.login-page-component-container input::placeholder,
.login-page-component-container textarea::placeholder {
  color: #a0a1a3;
}

.login-page-component-container .password-section-container {
  position: relative;
}

.login-page-component-container .show-hide-password-container {
  position: absolute;
  right: 10px;
  top: 15%;
  bottom: 15%;
  width: 25px;
  display: flex;
  cursor: pointer;
}

[dir="rtl"] .login-page-component-container .show-hide-password-container {
  right: auto;
  left: 10px;
}

.login-page-component-container .show-hide-password-container img {
  width: 100%;
}

.login-page-component-container .error-unknown-email,
.login-page-component-container .error-incorrect-password {
  border: 1px solid #cb061d;
}

.login-page-component-container .error-unknown-email:focus,
.login-page-component-container .error-incorrect-password:focus {
  outline: 1px solid #cb061d;
}

.login-page-component-container .error-msg-unknown-email-container,
.login-page-component-container .error-msg-incorrect-password-container,
.login-page-component-container .login-error-msg {
  padding: 2px 8px;
  font-size: 12px;
  font-family: 'Open Sans Std', sans-serif;
}

.login-page-component-container .options-container {
  padding-bottom: 10px;
  height: 45px;
}

.login-page-component-container .checkbox {
  height: 30px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
  letter-spacing: 0px;
  color: #616365;
}

.login-page-component-container .form-checkbox {
  display: none;
}

.login-page-component-container .custom-checkbox {
  display: flex;
  align-items: center;
  font-family: 'Open sans Std', sans-serif;
  color: #616365;
}

.login-page-component-container .custom-checkbox .form-checkbox + .checkmark {
  width: 20px;
  height: 20px;
  border: 1px solid #92d400;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  background: white;
  position: relative;
}

[dir="rtl"] .login-page-component-container .custom-checkbox .form-checkbox + .checkmark {
  margin-right: 0;
  margin-left: 10px;
}

.login-page-component-container .custom-checkbox .form-checkbox:checked + .checkmark {
  background: #92d400;
  border: 1px solid #92d400;
}

.login-page-component-container .custom-checkbox .form-checkbox:checked + .checkmark::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 37%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}

.login-page-component-container .forget-password-wrapper {
  padding-bottom: 20px;
}

.login-page-component-container .forget-password-wrapper p {
  width: max-content;
  font-family: 'Open Sans Std', sans-serif;
  color: #009df4;
  font-size: 17px;
  cursor: pointer;
}

.login-page-component-container .login-btn-and-error-msg-container {
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-page-component-container .login-btn-wrapper {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-page-component-container .login-btn {
  background: #92d400;
  color: #ffffff;
  font-family: 'VAG Rounded Std', sans-serif;
  font-size: 29px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  padding: 6px 50px;
}

[dir="rtl"] .login-page-component-container .login-btn {
    font-size: min(26px, calc(14px + 2vw));
}

.login-page-component-container .loading-spinner-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-page-component-container .login-error-msg-container {
  text-align: center;
}

.login-page-component-container .login-error-msg-container p {
  word-wrap: break-word;
}

.login-page-component-container .can-not-login-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 25px;
}

.login-page-component-container .registration-container {
  padding: 5px;
  text-align: center;
}

.login-page-component-container .registration-container span {
  cursor: pointer;
}

.login-page-component-container .can-not-login-text-container p {
  color: #616365;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
}

.login-page-component-container .can-not-login-text-container .register-btn {
  color: #009df4;
  font-size: 15px;
}

@media (max-width: 425px) {
  .login-page-component-container .form-input {
    font-size: calc(10px + 0.8vw);
  }

  .login-page-component-container .error-msg-unknown-email-container,
  .login-page-component-container .error-msg-incorrect-password-container,
  .login-page-component-container .login-error-msg {
    font-size: calc(6px + 1.5vw);
  }
}

@media (max-width: 375px) {
  .login-page-component-container .registration-container p {
    font-size: calc(8px + 1.5vw);
  }

  .login-page-component-container .can-not-login-text-container .register-btn {
    font-size: calc(8px + 1.5vw);
  }

  .login-page-component-container .can-not-login-text-container p {
    font-size: calc(8px + 1.5vw);
  }
}

@media (max-width: 320px) {
  .login-page-component-container .info-text-container .info-text {
    max-width: 200px;
    font-size: 24px;
  }

  .login-page-component-container .form-input {
    font-size: calc(7px + 1.5vw);
  }

  .login-page-component-container .error-msg-unknown-email-container,
  .login-page-component-container .error-msg-incorrect-password-container,
  .login-page-component-container .login-error-msg {
    font-size: calc(6px + 1.2vw);
  }

  .login-page-component-container .forget-password-wrapper p {
    font-size: 15px;
  }

  .login-page-component-container .login-btn {
    font-size: 20px;
  }
}
</style>